import { useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const TRIGGER = 64;

export const PullToRefresh = ({ onRefresh, children }) => {
  const start = useRef(null);
  const [pull, setPull] = useState(0);
  const [busy, setBusy] = useState(false);

  const onStart = (e) => { start.current = window.scrollY <= 0 ? e.touches[0].clientY : null; };
  const onMove = (e) => {
    if (start.current == null || busy) return;
    const d = e.touches[0].clientY - start.current;
    setPull(d > 0 ? Math.min(d * 0.5, 90) : 0);
  };
  const onEnd = async () => {
    const fire = pull >= TRIGGER && !busy;
    setPull(0);
    start.current = null;
    if (!fire) return;
    setBusy(true);
    try { await onRefresh(); } finally { setBusy(false); }
  };

  return (
    <div onTouchStart={onStart} onTouchMove={onMove} onTouchEnd={onEnd} data-testid="pull-to-refresh">
      <div className="flex items-end justify-center overflow-hidden transition-[height] duration-200" style={{ height: busy ? 44 : pull }}>
        <RefreshCw data-testid="pull-indicator" className={`mb-2 h-5 w-5 text-brand ${busy ? "animate-spin" : ""}`} style={{ transform: busy ? undefined : `rotate(${pull * 4}deg)`, opacity: busy ? 1 : pull / TRIGGER }} />
      </div>
      {children}
    </div>
  );
};
